export const NOTIFICATION_VERSION_KEY = 'notification-version';
